export class NodeTree {
    constructor(name) {
        this.name = name;
        this.children = [];
    }

    addPath(path) {
        let child;
        const parts = path.split('.', 2);
        child = this.children.find(c => c.name === parts[0]);
        if (!child) {
            child = new NodeTree(parts[0]);
            this.children.push(child);
        }
        if (parts.length === 2) {
            child.addPath(parts[1]);
        }
    }

    isLeaf() {
        return this.children.length === 0;
    }

    format(padding = 4, offset = 2) {
        const currentPadding = (' ').repeat(padding * offset);
        if (this.isLeaf()) {
            // Format Leaf
            return `${currentPadding}${this.name}`;
        }
        // Format children
        return `${currentPadding}${this.name} {
${this.children.map(child => child.format(padding, offset + 1)).join('\n')}
${currentPadding}}`;
    }
}
